import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExport = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "m12 5-.707-.707.707-.707.707.707L12 5Zm1 9a1 1 0 1 1-2 0h2ZM6.293 9.293l5-5 1.414 1.414-5 5-1.414-1.414Zm6.414-5 5 5-1.414 1.414-5-5 1.414-1.414ZM13 5v9h-2V5h2Z"
	}), /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeWidth: 2,
		d: "M5 16v1a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-1"
	})]
});
export default SvgExport;
